// Compresse une image File/Blob côté navigateur.
// Sortie WebP par défaut (qualité 82) avec fallback JPEG automatique
// pour les rares navigateurs ne supportant pas l'encodage WebP côté canvas.
// Utilisé pour les uploads Configurateur, Diagnostic, etc.
export function compressImage(
  file,
  { maxDim = 1600, quality = 0.82, preferWebP = true } = {}
) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("read_failed"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("decode_failed"));
      img.onload = () => {
        const ratio = Math.min(1, maxDim / Math.max(img.width, img.height));
        const w = Math.round(img.width * ratio);
        const h = Math.round(img.height * ratio);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);

        let dataUrl = "";
        if (preferWebP) {
          dataUrl = canvas.toDataURL("image/webp", quality);
        }
        // Si le navigateur ne supporte pas WebP, toDataURL renvoie un
        // PNG/JPEG par défaut. On detecte ça et on bascule en JPEG.
        if (!dataUrl || !dataUrl.startsWith("data:image/webp")) {
          dataUrl = canvas.toDataURL("image/jpeg", quality);
        }
        resolve(dataUrl);
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
